import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

import { setAnalyticsEvent } from '../../../lib/analytics/state'

import checkMark from '../../../img/icons/checkmark.svg'

const ResourceFiltersLink = ({ count, name, type }) => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const isActive = params.get('type') === type

  const handleClick = () => {
    if (isActive) {
      params.delete('type')
    } else {
      params.set('type', type)
      setAnalyticsEvent({
        event: 'library_filter_select',
        title: name,
      })
    }

    navigate(`${location.pathname}?${params.toString()}`)
  }

  return count > 0 || isActive ? (
    <li className="mb-5">
      <button onClick={handleClick} className="flex items-center gap-3.5">
        <div
          className={`w-[22px] h-[22px] rounded border transition-colors duration-200 ease-in-out
          ${isActive ? 'bg-brand-navy border-brand-navy' : 'border-gray-300'}`}
        >
          {isActive && <img src={checkMark} alt="Checkmark" className="w-full h-full p-[3px]" />}
        </div>
        <div className="text-sm xl:text-base">{name}</div>
      </button>
    </li>
  ) : null
}

ResourceFiltersLink.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
}

export default ResourceFiltersLink
